import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CategoryItemList from '../../components/CategoryItemList/CategoryItemList';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import './CatalogCategoryPage.css';
import { useTranslation } from "react-i18next";
import { apiFetch } from "../../utils/api";
import Spinner from '../../components/Spinner/Spinner';
import { useCartContext } from '../../hooks/useCartContext';

const CatalogCategoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const { items: cartItems, addItem, removeItem } = useCartContext();

  useEffect(() => {
    const fetchCategory = async () => {
      setLoading(true);
      const res = await apiFetch(`/api/public/categories/${id}`, {
        headers: {
          Locale: i18n.language,
        },
      });
      const data = await res.json();
      setCategory(data);
      setLoading(false);
    };
    fetchCategory();
  }, [id, i18n.language]);

  if (loading) return <Spinner />;
  if (!category) return <div>Category not found.</div>;

  return (
    <div className="catalog-page">
      <Breadcrumb items={[
        { label: t("catalog.breadcrumb") },
        { label: category.title },
      ]} />
      <h1>{category.title || 'Catalog Category'}</h1>
      <div className="catalog-page-desc">{category.translations?.description || ''}</div>
      <CategoryItemList
        items={category.items}
        onItemClick={(itemId) => navigate(`/catalog/item/${itemId}?from=${id}`)}
        onAdd={({ _id, name, image }) =>
          addItem({
            id: _id,
            name,
            image,
            categoryId: id,
            categoryName: category.title ?? '',
          })
        }
        onRemove={removeItem}
        getInCart={(_id) => cartItems.some((i) => i.id === _id)}
      />
    </div>
  );
};

export default CatalogCategoryPage;
